import { useEffect, useState, useRef } from "react";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import { Select } from "semantic-ui-react";
import SearchDropdown from "../../input/SearchDropdown";
import { statusByContext } from "../../../api/statusApi";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import { FORMS, MODULES, STATUS_GROUPS } from "../../../const";
import Input from "../../input/Input";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { userCustomerGroupDropdown } from "../../../api/UserCustomerApi";
import useUserCompany from "../../../hooks/useUserCompany";
import { useSearchParams } from "react-router-dom";


const JobMonitorSearch = ({ searchResHandler, resetHanler }) => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction],
  );
  const jobMonitorPermission = auth[FORMS?.JOB?.MONITOR?.form];
  const dateTypeFieldPermission = jobMonitorPermission?.date_type?.VIEW;
  const fromDateFieldPermission = jobMonitorPermission?.from_date?.VIEW;
  const toDateFieldPermission = jobMonitorPermission?.to_date?.VIEW;
  const jobStatusFieldPermission = jobMonitorPermission?.job_status?.VIEW;
  const jobNumberFieldPermission = jobMonitorPermission?.job_number?.VIEW;
  const requestNumberFieldPermission =
    jobMonitorPermission?.request_number?.VIEW;
  const vehicleNumberFieldPermission =
    jobMonitorPermission?.vehicle_number?.VIEW;

  const userCustomerGroupFieldPermission =
    jobMonitorPermission?.user_customer_group?.VIEW;
  const flagTypeFieldPermission = jobMonitorPermission?.flag_type?.VIEW;
  const resolvedFieldPermission = jobMonitorPermission?.resolved?.VIEW;
  const statusFieldPermission = jobMonitorPermission?.status?.VIEW;
  const activeFieldPermission = jobMonitorPermission?.active?.VIEW;

  const requestCustomerFieldPermission =
    jobMonitorPermission?.request_customer?.VIEW;
  const shipperPlantFieldPermission = jobMonitorPermission?.shipper_plant?.VIEW;
  const transporterFieldPermission = jobMonitorPermission?.transporter?.VIEW;
  const vehicleTypeFieldPermission = jobMonitorPermission?.vehicle_type?.VIEW;
  const jobOnTimeFieldPermission = jobMonitorPermission?.job_on_time?.VIEW;
  const shipmentCreatorFieldPermission =
    jobMonitorPermission?.shipment_creator?.VIEW;

  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [flagedTypeOptions, setFlagedTypeOptions] = useState([]);
  const [resolvedOptions, setResolvedOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [userCustomerGroupOptions, setUserCustomerGroupOptions] = useState([]);

  const [dateType, setDateType] = useState(5);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [vehicleType, setVehicleType] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [onTime, setOnTime] = useState(null);
  const [transporter, setTransporter] = useState([]);
  const [shipper, setShipper] = useState([]);
  const [jobStatus, setJobStatus] = useState([]);
  const [jobNos, setJobNos] = useState("");
  const [reqNos, setReqNos] = useState("");
  const [vehNos, setVehNos] = useState("");
  const [flagedType, setFlagedType] = useState("");
  const [resolved, setResolved] = useState("");
  const [status, setStatus] = useState("");
  const [active, setActive] = useState("");
  const [customerGroup, setCustomerGroup] = useState(null);
  const [shipmentCreator, setShipmentCreator] = useState(null);

  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reloadDates, setReloadDates] = useState(true);
  const userCompany = useUserCompany();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const {
        date_types: dateTypeData,
        "flag_type#1": flagedTypeData,
        yesno: resolvedData,
        status: statusData,
        active: activeData,
      } = await getBulkDropdownData([
        { key: "date_types" },
        { key: "flag_type", group: "1" },
        { key: "yesno" },
        { key: "status" },
        { key: "active" },
      ]);

      setDateTypeOptions(dateTypeData);
      setFlagedTypeOptions(flagedTypeData);
      setResolvedOptions(resolvedData);
      setStatusOptions(statusData);
      setActiveOptions(activeData);

      const userCustomerGroupData = await userCustomerGroupDropdown();
      setUserCustomerGroupOptions(userCustomerGroupData);
      const jobStatusData = await statusByContext(
        userData.type === 2
          ? STATUS_GROUPS.CUSTOMER_STATUS
          : userData.type === 3
            ? STATUS_GROUPS.TRANSPORTER_STATUS
            : STATUS_GROUPS.INTERNAL_STATUS,
      );
      setJobStatusOptions(jobStatusData);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

 // ── Auto-search from chatbot navigation link ──────────────────────────
  useEffect(() => {
    const jobNo = searchParams.get("jobNo");
    const requestNo = searchParams.get("requestNo");

    if (!jobNo && !requestNo) return;
    if (isLoading) return;

    // Set wider date range for auto-search (frist start day to today)
    const formattedFrom = "2025-04-01";
    const formattedTo = new Date().toISOString().split("T")[0];

    setFromDate(formattedFrom);
    setToDate(formattedTo);

    if (jobNo) {
      setJobNos(jobNo);
    }
    if (requestNo) {
      setReqNos(requestNo);
    }

    // Auto-trigger search after a short delay (allow state to update)
    setTimeout(() => {
      searchResHandler({
        lDataType: dateType,
        dFromData: formattedFrom,
        dToDate: formattedTo,
        sCustomer: null,
        sShipper: null,
        sJobStatus: null,
        sJobNos: jobNo || "",
        sRequestNos: requestNo || "",
        sVehicleNos: "",
        sFlaggedType: "",
        sResolved: "",
        sStatus: "",
        sActive: "",
        customerGroup: null,
        sTransporters: null,
        lCompany: userCompany?.comId,
        vehicleType: null,
        jobOnTime: null,
        shipmentCreator: null,
      });

      // Clean up URL params after search
      setSearchParams({}, { replace: true });
    }, 500);
  }, [isLoading, searchParams]);

  const onSearch = (e) => {
    if (!dateType || !fromDate || !toDate) {
      toast.warn("Date range and date type is mandatory", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    e.preventDefault();
    searchResHandler({
      lDataType: dateType,
      dFromData: fromDate,
      dToDate: toDate,
      sCustomer: customer.length > 0 ? customer.join(",") : null,
      sShipper: shipper.length > 0 ? shipper.join(",") : null,
      sJobStatus:
        jobStatus && jobStatus.length > 0 ? jobStatus.join(",") : null,
      sJobNos: jobNos,
      sRequestNos: reqNos,
      sVehicleNos: vehNos ? vehNos.toUpperCase() : "",
      sFlaggedType: flagedType.toString(),
      sResolved: resolved.toString(),
      sStatus: status.toString(),
      sActive: active.toString(),
      customerGroup: customerGroup,
      sTransporters: transporter.length > 0 ? transporter.join(",") : null,
      lCompany: userCompany.comId,
      vehicleType: vehicleType.length > 0 ? vehicleType.join(",") : null,
      jobOnTime: onTime,
      shipmentCreator: shipmentCreator,
    });
  };

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setDateType(5);
    setJobNos("");
    setReqNos("");
    setVehNos("");
    setFlagedType("");
    setResolved("");
    setStatus("");
    setActive("");
    setCustomer([]);
    setJobStatus([]);
    setShipper([]);
    setTransporter([]);
    setVehicleType([]);
    setOnTime("");
    setCustomerGroup(null);
    setShipmentCreator(null);
    setReloadDates(true);
    resetHanler();
  };

  return (
    <div style={{ marginTop: "10px" }}>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <h4 className="ui dividing header">Information</h4>

          <div
            className="four fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {dateTypeFieldPermission && (
              <div className="field">
                <Dropdown
                  required={true}
                  options={dateTypeOptions}
                  label="Date Type"
                  placeholder="Date Type"
                  style={{ height: "20px" }}
                  value={dateType}
                  onChange={(e, data) => {
                    setDateType(data.value);
                  }}
                  clearable={false}
                />
              </div>
            )}
            {fromDateFieldPermission && (
              <div className="field">
                <Input
                  required={true}
                  type="date"
                  label="From Date"
                  name="fromDate"
                  max={toDate ?? null}
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                  }}
                />
              </div>
            )}
            {toDateFieldPermission && (
              <div className="field">
                <Input
                  required={true}
                  label="To Date"
                  type="date"
                  name="toDate"
                  min={fromDate}
                  value={toDate}
                  disabled={!fromDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                  }}
                />
              </div>
            )}
            {jobStatusFieldPermission && (
              <Dropdown
                clearable
                search={true}
                options={jobStatusOptions}
                placeholder="Job Status"
                label="Job Status"
                value={jobStatus}
                onChange={(e, data) => {
                  setJobStatus(data.value);
                }}
                multiple={true}
              />
            )}
          </div>

          <div className="field">
            <div
              className="four fields"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {jobNumberFieldPermission && (
                <div className="field">
                  <label>Job Numbers</label>
                  <input
                    type="text"
                    placeholder="Ex:JOB-0000123"
                    name="jobnos"
                    value={jobNos}
                    onChange={(e) => {
                      setJobNos(e.target.value);
                    }}
                  />
                </div>
              )}
              {requestNumberFieldPermission && (
                <div className="field">
                  <label>Request Numbers</label>
                  <input
                    type="text"
                    placeholder="Ex:REQ-00000123"
                    name="reqnos"
                    value={reqNos}
                    onChange={(e) => {
                      setReqNos(e.target.value);
                    }}
                  />
                </div>
              )}
              {vehicleNumberFieldPermission && (
                <div className="field">
                  <label>Vehicle Numbers</label>
                  <input
                    type="text"
                    placeholder="Ex:LG-0123"
                    name="vehnos"
                    value={vehNos}
                    onChange={(e) => {
                      setVehNos(e.target.value);
                    }}
                  />
                </div>
              )}
              {userCustomerGroupFieldPermission && (
                <SearchDropdown
                  value={customerGroup}
                  label={"User Customer Group"}
                  name={"customerGroup"}
                  clearable={true}
                  onClear={() => setCustomerGroup(null)}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => setCustomerGroup(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "customer_group",
                  }}
                />
              )}
            </div>
            <div
              className="four fields"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {flagTypeFieldPermission && (
                <div className="field">
                  <label>Flag Type</label>
                  <Select
                    clearable
                    search
                    icon="search"
                    options={flagedTypeOptions}
                    placeholder="Flag Type"
                    style={{ height: "20px" }}
                    value={flagedType}
                    onChange={(e, data) => {
                      setFlagedType(data.value);
                    }}
                  />
                </div>
              )}
              {resolvedFieldPermission && (
                <div className="field">
                  <label>Resolved</label>
                  <Select
                    clearable
                    options={resolvedOptions}
                    placeholder="Resolved"
                    style={{ height: "20px" }}
                    value={resolved}
                    onChange={(e, data) => {
                      setResolved(data.value);
                    }}
                  />
                </div>
              )}
              {statusFieldPermission && (
                <div className="field">
                  <label>Status</label>
                  <Select
                    clearable
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                </div>
              )}
              {activeFieldPermission && (
                <div className="field">
                  <label>Active</label>
                  <Select
                    clearable
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>
              )}
            </div>
            <div
              className="four fields"
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              {requestCustomerFieldPermission && userData.type === 1 ? (
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setCustomer((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) =>
                    setCustomer((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Customer",
                  }}
                  label="Request Customer"
                />
              ) : (
                requestCustomerFieldPermission && (
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    multiple={true}
                    multiValueRemoveHandler={(key) => {
                      setCustomer((prev) =>
                        prev.filter((item) => item !== parseInt(key)),
                      );
                    }}
                    onResultSelect={(data) =>
                      setCustomer((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "user_stakeholder",
                      value: "Requesting Customer",
                      param2: user.username,
                    }}
                    label="Request Customer"
                  />
                )
              )}

              {shipperPlantFieldPermission && (
                <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setShipper((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) =>
                    setShipper((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 1
                      ? {
                          type: "stakeholder_type",
                          value: "Shipper",
                          param2: customer.length > 0 ? customer.join(",") : "",
                        }
                      : {
                          type: "user_stakeholder",
                          value: "Shipper",
                          param1: customer.length > 0 ? customer.join(",") : "",
                          param2: user.username,
                        }
                  }
                  label="Shipper/Plant"
                />
              )}
              {transporterFieldPermission && (
                <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setTransporter((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) =>
                    setTransporter((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 3
                      ? {
                          type: "user_stakeholder",
                          value: "Transporter",
                          param2: user.username,
                        }
                      : {
                          type: "stakeholder_type",
                          value: "Transporter",
                        }
                  }
                  label="Transporter"
                />
              )}
              {vehicleTypeFieldPermission && (
                <SearchDropdown
                  key={
                    resetSearchFields
                      ? `vehicle_type_reset_${Date.now()}`
                      : "vehicle_type"
                  }
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  occupySpace={false}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setVehicleType((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  onResultSelect={(data) =>
                    setVehicleType((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "vehicle_type",
                    value: "",
                  }}
                  label="Vehicle Type"
                />
              )}
            </div>
            <div
              className="four fields"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {jobOnTimeFieldPermission && (
                <div className="field">
                  <label>Job On-Time</label>
                  <Select
                    clearable
                    options={resolvedOptions}
                    placeholder="ontime"
                    style={{ height: "20px" }}
                    value={onTime}
                    onChange={(e, data) => {
                      setOnTime(data.value);
                    }}
                  />
                </div>
              )}
              {shipmentCreatorFieldPermission && (
                <SearchDropdown
                  value={shipmentCreator}
                  label={"Shipment Creator"}
                  name={"shipment_creator"}
                  clearable={true}
                  onClear={() => setShipmentCreator(null)}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => setShipmentCreator(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "user",
                    value: userData.type.toString(),
                  }}
                />
              )}
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <div className="field" style={{ width: "100%" }}>
                <Button template="search" onClick={onSearch} />
                <Button template="searchReset" onClick={onReset} />
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default JobMonitorSearch;
